<template>
  <div id="app">
    <router-view v-if="this.isConnected"/>
    <Login v-else/>
  </div>
</template>
<script>
  export default {
    watch:{
      $route (to, from){
        this.demarrer()
      }
    },
    mounted() {
      this.demarrer()
    },
    methods : {
      demarrer() {
        if(this.isConnected) {
          axios.post('check-jwt').then(response => {
            if(!response.data['check-jwt']) {
              this.logOut();
            }
          })
        }
      }
    }
  }
</script>
<style lang="scss">
html {
  height: 100%;
}
body {
  --color-main: #fee100;
  --color-hover: #fee100;
  --color-link-hover:#dddddd;
  --color-link-selected:white;
  min-height: 100%;

  .button.is-warning.is-outlined {
    border-color: var(--color-main);
    color: var(--color-main);
    &:hover {
      background-color: var(--color-main);
    }
  }
}
</style>
